import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {
  PICKUP,
  DELIVERY,
  DROPOFF,
} from '../modules/OrderSetting/orderSettingTypes';

function useLocation() {
  const [currentLocation, setCurrentLocation] = useState(null);

  const {
    interOrderType,
    interDeliveryDetails,
    interPickUpDetails,
    interDropOffDetails,
  } = useSelector(state => state.orderSettingReducer);

  useEffect(() => {
    if (interOrderType === PICKUP) {
      setCurrentLocation(interPickUpDetails);
    } else if (interOrderType === DELIVERY) {
      setCurrentLocation(interDeliveryDetails);
    } else if (interOrderType === DROPOFF) {
      setCurrentLocation(interDropOffDetails);
    }
  }, [
    interOrderType,
    interPickUpDetails,
    interDeliveryDetails,
    interDropOffDetails,
  ]);

  const acceptedOrderTypes = currentLocation
    ? currentLocation.accepted_order_types
    : null;

  return {interOrderType, currentLocation, acceptedOrderTypes};
}

export default useLocation;
